var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "south-korea",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(0.001 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M177.392,172.174c0,1.3-2.336,4.565-5.217,4.565s-5.217-3.261-5.217-4.565a5.217,5.217,0,0,1,10.435,0Z",
    transform: "translate(-157.174 -157.174)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M177.392,256a5.217,5.217,0,1,1-10.435,0",
    transform: "translate(-157.174 -241)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 1.957,
    height: 1.304,
    transform: "translate(20.534 19.612) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 1.957,
    height: 1.304,
    transform: "translate(18.228 21.918) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 1.957,
    height: 1.304,
    transform: "translate(23.302 22.378) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 1.957,
    height: 1.304,
    transform: "translate(20.996 24.685) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 1.957,
    height: 1.304,
    transform: "translate(21.918 20.995) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 1.957,
    height: 1.304,
    transform: "translate(19.612 23.301) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 5.217,
    height: 1.304,
    transform: "translate(23.302 10.388) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 1.957,
    height: 1.304,
    transform: "translate(19.613 9.467) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 1.957,
    height: 1.304,
    transform: "translate(21.918 11.772) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 1.957,
    height: 1.304,
    transform: "translate(22.378 6.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 1.957,
    height: 1.304,
    transform: "translate(24.685 9.006) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 5.217,
    height: 1.304,
    transform: "translate(5.316 20.996) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 1.957,
    height: 1.304,
    transform: "translate(9.005 21.917) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 1.957,
    height: 1.304,
    transform: "translate(6.7 19.612) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 5.217,
    height: 1.304,
    transform: "translate(8.083 18.228) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 5.217,
    height: 1.304,
    transform: "translate(9.006 5.316) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 5.217,
    height: 1.304,
    transform: "translate(10.389 6.699) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 5.217,
    height: 1.304,
    transform: "translate(11.773 8.083) rotate(135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.58947fdea193405ab6bfddb65aa9945b.svg";
export { ForwardRef as ReactComponent };